import { render, staticRenderFns } from "./IndexIntegratedAddressModal.vue?vue&type=template&id=fbc09460"
import script from "./IndexIntegratedAddressModal.vue?vue&type=script&lang=js"
export * from "./IndexIntegratedAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports